import React, { useEffect, useState } from 'react'
// import { useAdminStats } from '../hooks/useStats';
import { DEFAULT_CHAIN, contract } from '../helper/constant';
import { toast } from 'react-toastify';

import stakeAbi from '../json/bscstake.json';
import { getWeb3 } from '../helper/connectors';
import { useAdminStats } from '../hooks/useBscAccount';
import { getContract } from '../helper/contractHelper';
import { useAccount, useNetwork } from 'wagmi';
import { useEthersSigner } from "../hooks/useEthersProvider";



export default function Admin() {
    const { address , isConnected } = useAccount();
    const { chain } = useNetwork();
    const [updater,setUpdater] = useState(0);
    const [deenAddress,setDeenAddress] = useState('');
    const [defaultRef,setDefaultRef] = useState('');
    const [levelRate,setLevelRate] = useState([]);
    const [pauser,setPauser] = useState(false);
    const [wpauser,setWpauser] = useState(false);
    const [SAPY,setSAPY] = useState(0);
    const [minReward,setMinReward] = useState(0);
    const [transferOwnership,setTransferOwnership] = useState('');
    const [rescueToken,setRescueToken] = useState('');
    const stats = useAdminStats(updater);
    const signer = useEthersSigner()

    useEffect(()=>{
        setDeenAddress(stats.DeenCoin)
        setDefaultRef(stats.defaultRef)
        setPauser(stats.pauser)
        setWpauser(stats.wpauser)
        setSAPY(stats.SAPY)
        setMinReward(stats.minReward)
        setTransferOwnership(stats.owner)
    },[stats])
    
    
    const handleSubmit = async(id) => {
        if (address && isConnected) {
            if (chain.id === DEFAULT_CHAIN) {
                
                try {
                    
                    let stakeContract = getContract(stakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS, signer);
                    let tx;
                    if(id === 1){
                        tx = await stakeContract.setBKRCoin(deenAddress, { 'from': address });
                    }
                    else if(id === 2){
                        
                        tx = await stakeContract.setDefaultRef(defaultRef, { 'from': address });
                    }
                    else if(id === 3){
                        let rates = levelRate.split(',');
                        tx = await stakeContract.setLevelRate(rates, { 'from': address });
                    }
                    else if(id === 4){
                        tx = await stakeContract.setPauser(pauser, { 'from': address });

                    }
                    else if(id === 5){
                        tx = await stakeContract.setWPauser(wpauser, { 'from': address });
                    }
                    else if(id === 6){
                        let min = minReward * 100;
                        tx = await stakeContract.setminReward( min , { 'from': address });
                    }
                    else if(id === 7){
                        tx = await stakeContract.transferOwnership(transferOwnership, { 'from': address });
                    }
                    else if(id === 8){  
                        tx = await stakeContract.rescueToken(rescueToken, { 'from': address });
                    }
                    else if(id === 9){
                        tx = await stakeContract.rescueFunds({ 'from': address });
                    }
                    else if(id === 10){
                        let apy = SAPY * 100
                        tx = await stakeContract.setSAPY(apy, { 'from': address });
                    }
                    else{
                        toast.error('something went wrong');
                        return false;
                    }
                    toast.loading('Waiting for confirmation.');
                    var interval = setInterval(async function () {
                        let web3 = getWeb3();
                        var response = await web3.eth.getTransactionReceipt(tx.hash);
                        if (response != null) {
                            clearInterval(interval)
                            if (response.status === true) {
                                toast.dismiss()
                                toast.success('success ! your last transaction is success');
                                setUpdater(Math.random());
                                
                            }
                            else if (response.status === false) {
                                toast.dismiss()
                                toast.error('error ! Your last transaction is failed.');
                                setUpdater(Math.random());
                                
                            }
                            else {
                                toast.dismiss()
                                toast.error('error ! something went wrong.');
                                setUpdater(Math.random());
                                
                            }
                        }
                    }, 5000);
                }
                catch (err) {
                    toast.dismiss()
                    toast.error(err.reason ? err.reason : err.message);
                    
                }
            }
            else {
                toast.dismiss()
                toast.error('Please switch network to binanace chain');
            }

        } else {
            toast.dismiss()
            toast.error('Please connect wallet');
        }
    }
    


    return (
        <div className="container bg-dark text-white" style={{marginTop : "100px" , marginBottom : "100px"}}>
            <table class="table text-white">
                <thead>
                    <tr>
                        <th scope="col">No.</th>
                        <th scope="col">Function Name</th>
                        <th scope="col">Input</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">1</th>
                        <td>Set BKRCoin</td>
                        <td>
                            <input type="text" class="form-control" placeholder="Enter Token Address" value={deenAddress} onChange={(e)=>setDeenAddress(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(1)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">2</th>
                        <td>Set Default Ref</td>
                        <td>
                            <input type="text" class="form-control" placeholder="Enter Default Referral Address" value={defaultRef} onChange={(e)=>setDefaultRef(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(2)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">3</th>
                        <td>Referral Level Rate</td>
                        <td>
                            <input type="text" class="form-control" placeholder="Enter comma seprate value 10,5,2" value={levelRate} onChange={(e)=>setLevelRate(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(3)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">4</th>
                        <td>Deposit Pause</td>
                        <td>
                            <input type="text" class="form-control" placeholder="true or false" value={pauser} onChange={(e)=>setPauser(e.target.value)}  />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(4)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">5</th>
                        <td>Claim Pauser</td>
                        <td>
                            <input type="text" class="form-control" placeholder="true or false" value={wpauser} onChange={(e)=>setWpauser(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(5)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">6</th>
                        <td>Min Reward Time(in seconds)</td>
                        <td>
                            <input type="text" class="form-control" placeholder="true or false" value={minReward} onChange={(e)=>setMinReward(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(6)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">7</th>
                        <td>transfer Ownership</td>
                        <td>
                            <input type="text" class="form-control" placeholder="Enter address" value={transferOwnership} onChange={(e)=>setTransferOwnership(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(7)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">8</th>
                        <td>Withdraw Tokens</td>
                        <td>
                            <input type="text" class="form-control" placeholder="Enter token address" value={rescueToken} onChange={(e)=>setRescueToken(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(8)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">9</th>
                        <td>Withdraw BNB</td>
                        <td>
                            
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(9)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">10</th>
                        <td>APY</td>
                        <td>
                            <input type="text" class="form-control" placeholder="Enter token address" value={SAPY} onChange={(e)=>setSAPY(e.target.value)} />
                        </td>
                        <td>
                            <button
                                className="theme-btn"
                                onClick={()=>handleSubmit(10)}
                            >
                                Submit
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
